// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  ProfileListDto,
  ProfileRightsListDto
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import { restGetUniqueHandler } from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;

export const requestGetProfiles = createEffect({
  handler: restGetUniqueHandler<ProfileListDto>(baseUrl + "/reference/profiles")
});

export const requestGetProfilesRights = createEffect({
  handler: restGetUniqueHandler<ProfileRightsListDto>(
    baseUrl + "/reference/profiles/rights"
  )
});
